'use client';
import React, { useState } from 'react';
import Image from 'next/image';
import AuthorDetailsPopup from './AuthorDetailsPopup';
import { tick } from '@/public';

const FactCheckHoverContainer = ({ details }: any) => {
  const [showPopup, setShowPopup] = useState(false);
  return (
    <section
      onMouseEnter={() => setShowPopup(true)}
      onClick={() => setShowPopup(true)}
      onMouseLeave={() => setShowPopup(false)}
    >
      <section className={`relative `}>
        <FactCheckAndVerifiedComp
          details={details?.factCheckedBy}
          text='Fact checked by'
        />
        {showPopup && (
          <section className='absolute left-[0px] top-[10px] z-[5] animate-[scale-in-tl_.2s_ease-in] pt-[30px] transition duration-300 ease-in-out'>
            <AuthorDetailsPopup details={details?.factCheckedBy} />
          </section>
        )}
      </section>
    </section>
  );
};

export default FactCheckHoverContainer;

export const FactCheckAndVerifiedComp = ({ details, text }: any) => (
  <section className=' group flex cursor-pointer items-center gap-[10px]'>
    <Image src={tick} alt='' className=' w-[18px] group-hover:saturate-0' />
    <p className=' group-hover:s-0 text-[14px] font-normal text-[#707b8d] dark:text-[#9ea8ac]'>
      {text}{' '}
      <span className='font-medium dark:text-[#00b4b9]'>
        {details?.data?.attributes?.name}
      </span>
    </p>
  </section>
);
